export default {
  setLanguage(language) {
    // axios.defaults.headers.common.Language = language
  },
  async getEmployees() {
    try {
      const response = await useApi('/api/employee-categories')
      return response
    }
    catch (error) {
      return error
    }
  },
  async getEmployee(id) {
    try {
      const response = await useApi(`/api/employees/${id}`)
      return response
    }
    catch (error) {
      return error
    }
  },
}
